import { Link } from 'react-router-dom';
import './DecoratorCard.css';

const SERVICES_HINDI = {
  'Shaadi': 'शादी', 'Engagement': 'सगाई', 'Birthday': 'Birthday',
  'Rice Ceremony': 'अन्नप्राशन', 'Griha Pravesh': 'गृह प्रवेश',
  'Corporate': 'Corporate', 'Baby Shower': 'Baby Shower', 'Anniversary': 'Anniversary'
};

const renderStars = (rating) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;
  let stars = '★'.repeat(full);
  if (half) stars += '½';
  stars += '☆'.repeat(5 - full - (half ? 1 : 0));
  return stars;
};

export default function DecoratorCard({ decorator }) {
  const coverImage = decorator.portfolio?.[0]?.image || 'https://images.unsplash.com/photo-1519167758481-83f550bb49b3?w=600';

  return (
    <div className="decorator-card card">
      {decorator.isFeatured && <div className="featured-ribbon">⭐ Featured</div>}

      <div className="card-image">
        <img src={coverImage} alt={decorator.businessName} />
        {!decorator.isVerified && <div className="unverified-badge">Pending Verification</div>}
      </div>

      <div className="card-body">
        <div className="card-header-row">
          <h3>{decorator.businessName}</h3>
          <span className="badge badge-gold">📍 {decorator.city}</span>
        </div>

        <div className="rating-row">
          <span className="stars">{renderStars(decorator.rating)}</span>
          <span className="rating-text">
            {decorator.rating > 0 ? `${decorator.rating} (${decorator.totalReviews} reviews)` : 'No reviews yet'}
          </span>
        </div>

        <p className="card-desc">{decorator.description?.substring(0, 80)}...</p>

        <div className="services-row">
          {decorator.services?.slice(0, 3).map(s => (
            <span key={s} className="badge badge-gray">{SERVICES_HINDI[s] || s}</span>
          ))}
          {decorator.services?.length > 3 && <span className="badge badge-gray">+{decorator.services.length - 3}</span>}
        </div>

        <div className="card-footer">
          <div className="price-range">
            <span>₹{(decorator.priceRange?.min / 1000).toFixed(0)}k</span>
            <span className="sep">—</span>
            <span>₹{(decorator.priceRange?.max / 1000).toFixed(0)}k</span>
          </div>
          <Link to={`/decorators/${decorator._id}`} className="btn btn-primary btn-sm">
            View Profile
          </Link>
        </div>
      </div>
    </div>
  );
}
